
	import ModeloUpdate from '@/views/paginas/sigap/modelos/ModeloUpdate.vue';   
    import { Options   } from "vue-class-component"; 
    import {  Qts } from "./Qts"; 
	import $ from "jquery"   
    import   SiteUtils   from '@/assets/ts/aplicacao/site';
    import { PerfilConfig } from "@/core/config/PerfisConfig"; 
	  
    @Options({
        name: "QtsEdicao",
        components: {   },  
        emits: [  'update-qts-alterado'],  
    }) 
    export default class QtsEdicao extends ModeloUpdate {
        
        async created() {  
            this.campos =  Qts.campos(); 
            await this.getStatus(); 
            if(this.modelo != null){
                this.modeloAlterado();
            } 
        }
   
        get hasPermissao(   ): boolean {
            return SiteUtils.hasPermissao( [ PerfilConfig.Admin ,  PerfilConfig.ChefeSTE,  PerfilConfig.AuxSTE ] ,  this.perfis); 
        }
   
        public modeloAlterado(){   
            this.formulario = {}
            if(this.modelo){  
                this.service.getModel(this.modelo.id) 
                .then(response => {   
                    this.formulario =  JSON.parse(JSON.stringify( response ));  
                    this.formulario.status = this.formulario.status.id;  
                })
                .catch(error => {
                    this.formulario = { };  
                });   
            } 
        }
 
        public sucesso(){  
            this.$emit("update-qts-alterado", null);     
            $("[data-bs-dismiss='modal']").trigger({ type: "click" });
        }

        
        public getdados(){  
            let dados = JSON.parse(JSON.stringify(this.formulario)); 
            return dados;
        }
         
        public async getStatus(){   
            this.processando = true ; 
            await this.service.getStatus( ) 
            .then(response => {  
                this.campos.push(
                    {
                        nome: "status",
                        type: "select",
                        label: "Status",
                        sm: 6,
                        lg: 3, 
                        disabled: false,
                        options: response.map((item) => { return { value: item.id, label: item.nome } })
                    },
                ); 
                this.processando = false ;    
            })
            .catch(error => { 
                this.processando = false ; 
                console.log(error);
            }); 
        } 
  
    } 
